import { useEffect, useRef } from "react";

export const useEffectOnlyUpdateOnChanges = (effect: () => void, deps: any[]) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            effect();
        } else {
            didMount.current = true;
        }
    }, deps);
};